import { SowInput, SowSelect } from './ValidationFields';
import { ServicesTableEditor } from './ServicesTableEditor';
import type { SowCohortFields } from '../../types';

interface Props {
  fields: SowCohortFields;
  onChange: (next: SowCohortFields) => void;
}

export function CohortContractForm({ fields, onChange }: Props): JSX.Element {
  const set = (patch: Partial<SowCohortFields>) => onChange({ ...fields, ...patch });

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <div className="card">
        <div className="card-hd"><span className="d-h3">Contract header</span></div>
        <div className="card-bd" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 12 }}>
          <div>
            <label className="input-label">Job number</label>
            <SowInput name="jobNumber" className="input d-mono" placeholder="O15820" value={fields.jobNumber} onChange={(e) => set({ jobNumber: e.target.value })} />
          </div>
          <div>
            <label className="input-label">Contract date</label>
            <SowInput name="contractDate" className="input" type="date" value={fields.contractDate} onChange={(e) => set({ contractDate: e.target.value })} />
          </div>
          <div>
            <label className="input-label">Effective date</label>
            <SowInput name="effectiveDate" className="input" type="date" value={fields.effectiveDate} onChange={(e) => set({ effectiveDate: e.target.value })} />
          </div>
          <div>
            <label className="input-label">Client legal name</label>
            <SowInput name="clientLegalName" className="input" placeholder="Amgen Capability Center Portugal" value={fields.clientLegalName} onChange={(e) => set({ clientLegalName: e.target.value })} />
          </div>
          <div>
            <label className="input-label">Delivery mode</label>
            <SowSelect name="deliveryMode" className="select" value={fields.deliveryMode} onChange={(e) => set({ deliveryMode: e.target.value as SowCohortFields['deliveryMode'] })}>
              <option value="in_person">In-person (travel + 50% deposit)</option>
              <option value="virtual">Virtual only (no travel)</option>
            </SowSelect>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-hd"><span className="d-h3">Services purchased</span></div>
        <div className="card-bd">
          <ServicesTableEditor
            groups={fields.groups}
            total={fields.total}
            onChange={(groups) => set({ groups })}
            onTotalChange={(total) => set({ total })}
          />
        </div>
      </div>

      <div className="card">
        <div className="card-hd"><span className="d-h3">Purchase order & billing</span></div>
        <div className="card-bd" style={{ display: 'grid', gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <label className="input-label" style={{ marginBottom: 0 }}>Purchase order required?</label>
            <div className="segmented">
              <button type="button" className={fields.poRequired ? 'on' : ''} onClick={() => set({ poRequired: true })}>Yes</button>
              <button type="button" className={!fields.poRequired ? 'on' : ''} onClick={() => set({ poRequired: false })}>No</button>
            </div>
            <SowInput name="poNumber"
              className="input d-mono"
              style={{ maxWidth: 240 }}
              placeholder="PO number (if available)"
              value={fields.poNumber ?? ''}
              onChange={(e) => set({ poNumber: e.target.value })}
            />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label className="input-label">Billing name</label>
              <SowInput name="billingName" className="input" value={fields.billingName} onChange={(e) => set({ billingName: e.target.value })} />
            </div>
            <div>
              <label className="input-label">Billing email</label>
              <SowInput name="billingEmail" className="input" value={fields.billingEmail} onChange={(e) => set({ billingEmail: e.target.value })} />
            </div>
            <div>
              <label className="input-label">Billing address</label>
              <SowInput name="billingAddress" className="input" value={fields.billingAddress} onChange={(e) => set({ billingAddress: e.target.value })} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div>
                <label className="input-label">City / State / Zip</label>
                <SowInput name="billingCityStateZip" className="input" value={fields.billingCityStateZip} onChange={(e) => set({ billingCityStateZip: e.target.value })} />
              </div>
              <div>
                <label className="input-label">Country</label>
                <SowInput name="billingCountry" className="input" value={fields.billingCountry} onChange={(e) => set({ billingCountry: e.target.value })} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
